<template>
  <div>
    <van-popup v-model="show" position="bottom" :style="{ height: '100%' }">
      <div class="title-box">
        推荐码
        <img
          src="../../../assets/images/common/icon-close.png"
          alt=""
          class="title-img"
          @click="close"
        />
      </div>
      <div class="content">
        <div class="title">输入6位推荐码</div>
        <div class="grid-input">
          <div class="inputStyle-box" v-for="(item, index) in captchas" :key="index">
            <input
              v-model="item.num"
              :id="'captcha' + index"
              @input="inputFinash(index)"
              @focus="adjust(index)"
              @keydown="inputDirection(index)"
              class="inputStyle"
              type="text"
              maxlength="1"
              pattern="[0-9]*"
              oninput="value=value.replace(/[^\d]/g,'');if(value.length>1)value=value.slice(0,1)"
            />
          </div>
        </div>
        <button :class="not_btn" :loading="saveLoading" @click="handleClick">确定</button>
        <div class="tipe">
          <p class="tipe-title">说明：</p>
          <p>1. 请输入正确的推荐码，可获得相应的优惠；</p>
        </div>
        <div class="customer" v-if="!isMiniOpen">
          2.如有疑问，请
          <span @click="Jum_customer" class="bule">联系客服</span>
          。
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { orderservic } from '@/api/order'
import { orderPrepare } from '@/api/order'
import { getPaySuccessURL } from '@/utils/cookies'
export default {
  name: 'RecommendCode',
  props: ['show', 'orderPrepareParam'],
  data() {
    return {
      // 当前输入框
      activeInput: 0,
      captchas: [{ num: '' }, { num: '' }, { num: '' }, { num: '' }, { num: '' }, { num: '' }],
      not_btn: 'not_btn',
      saveLoading: false, //是否可点击
      customer_info: [], //客服信息
      isMiniOpen: false,
    }
  },
  computed: {},
  methods: {
    getServicPrepare() {
      orderservic(this.orderPrepareParam).then((res) => {
        console.log(res)
        if (res.status === 1) {
          this.customer_info = res.data.customer_info
        } else {
          res.message && this.$toast(res.message)
        }
      })
    },
    // 关闭按钮
    close() {
      this.$emit('onClose')
    },
    Jum_customer() {
      window.open(this.customer_info.url)
    },

    // 自动校准输入顺序
    adjust(index) {
      let dom = document.getElementById('captcha' + this.activeInput)
      if (index !== this.activeInput && dom) {
        dom.focus()
      }
    },
    // 控制前后方向
    inputDirection(index) {
      let val = this.captchas[index].num
      // 回退键处理
      if (event.keyCode == 8 && val == '') {
        // 重新校准
        let dom = document.getElementById('captcha' + (index - 1))
        this.activeInput = index - 1
        if (dom) dom.focus()
      }
      if (event.keyCode != 8 && val != '') {
        let dom = document.getElementById('captcha' + (index + 1))
        this.activeInput = index + 1
        if (dom) dom.focus()
      }
    },
    // 输入框相互联动
    inputFinash(index) {
      let val = this.captchas[index].num
      this.activeInput = val ? index + 1 : index - 1
      let dom = document.getElementById('captcha' + this.activeInput)
      if (dom) dom.focus()
      if (index == this.captchas.length - 1) {
        let code = this.captchas.map((x) => x.num).join('')
        if (code.length == 6) {
          this.not_btn = 'btn'
          this.saveLoading = true
        } else {
          this.not_btn = 'not_btn'
          this.saveLoading = false
        }
      }
    },
    handleClick() {
      var code = ''
      this.captchas.forEach(function (e) {
        code += e.num.split(',')
      })
      if (code.length == 6) {
        this.orderPrepareParam.recommend_code = code
        orderPrepare(this.orderPrepareParam).then((res) => {
          console.log(res)
          if (res.status === 1) {
            this.$emit('update', code)
            res.message && this.$toast('使用成功~')
            setTimeout(() => {
              this.close()
            }, 500)
          } else {
            res.message && this.$toast(res.message)
          }
        })
      } else {
        this.saveLoading = false
      }
    },
  },
  mounted() {
    this.getServicPrepare()
    this.isMiniOpen = getPaySuccessURL() === 'mpopen'
  },
}
</script>
<style scoped>
input {
  -webkit-appearance: none;
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.173rem;
  line-height: 0.667rem;
  opacity: 0.9;
  font-size: 0.4rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #22242d;
  background: #ffffff;
  position: relative;
}

.title-img {
  position: absolute;
  top: 0.32rem;
  right: 0.533rem;
  width: 0.533rem;
  height: 0.533rem;
}

.content {
  width: 8.933rem;
  background: #fff;
  padding: 0 0.533rem;
  margin: 0 auto;
}

.title {
  font-size: 0.347rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  color: #18191a;
  margin: 0.64rem 0.32rem;
}

.grid-input {
  width: 8.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 0.213rem;
}

.inputStyle-box {
  width: 1.067rem;
  height: 1.44rem;
  border: 2px solid #f1f1f1;
  border-radius: 0.08rem;
}

.inputStyle {
  width: 0.9rem;
  height: 1.3rem;
  font-size: 0.693rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 600;
  color: #18191a;
  text-align: center;
  line-height: 1.44rem;
  border: none;
  margin: 0 auto;
  padding: 0;
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* vue的scope下 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.not_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8.933rem;
  height: 1.173rem;
  font-size: 0.427rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  color: #ffffff;
  background: var(--main-color);
  opacity: 0.3;
  border-radius: 0.56rem;
  margin-top: 0.747rem;
  border: none;
  -webkit-appearance: none;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8.933rem;
  height: 1.173rem;
  font-size: 0.427rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  color: #ffffff;
  background: var(--main-color);
  opacity: 1;
  border-radius: 0.56rem;
  margin-top: 0.747rem;
  border: none;
  -webkit-appearance: none;
}

.tipe {
  width: 8.933rem;
  margin-top: 0.853rem;
}

.tipe p {
  font-size: 0.347rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #c2c5cc;
  line-height: 0.587rem;
  letter-spacing: 0.017rem;
}

.bule {
  color: #448aff;
}

.tipe .tipe-title {
  margin-bottom: 0.213rem;
}

.customer {
  font-size: 0.347rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #c2c5cc;
  line-height: 0.587rem;
  letter-spacing: 0.017rem;
  margin-top: 0.533rem;
}
</style>
